<section id="content">
  <div class="section my-0 p-t-65">
    <div class="container" style="min-height: 650px">
      <div class="row" style="justify-content: center;">
        <!-- qp16 maintenance-->
        <div class="maintenance-container maintenance-margin" *ngIf="sitePrefix == 'lb'">
          <div class="maintenance-header-text">
            <p *ngIf="languageCode != 'bn'">NOTICE TO OUR VALUED CUSTOMERS</p>
            <p *ngIf="languageCode == 'bn'">প্রিয় গ্রাহকবৃন্দ</p>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <div class="maintenance-logo" [innerHTML]="svg.underMaintenanceIcon | safeHtml"></div>
          </div>
          <div class="maintenance-text">
            <p *ngIf="languageCode != 'bn'">
              We are excited to announce that LuckyBaji has successfully merged with Bwina! All member details and accounts have been seamlessly synchronized, ensuring a smooth transition for our players.
            </p>
            <p *ngIf="languageCode == 'bn'">
              আমরা আনন্দিত যে LuckyBaji সফলভাবে Bwina এর সাথে একীভূত হয়েছে। সকল সদস্য বিবরণ এবং অ্যাকাউন্ট সমন্বিত করা হয়েছে, যাতে আমাদের ক্রীড়াবিদদের জন্য সহজ ক্রমান্বয়ন নিশ্চিত করা যায়।
            </p>
            <p *ngIf="languageCode != 'bn'">
              You can now log in to your account directly on the Bwina site <a href="https://bwina888.com/" target="_blank">https://bwina888.com/</a> and continue enjoying all your favorite games and promotions.
            </p>
            <p *ngIf="languageCode == 'bn'">
              আপনার অ্যাকাউন্ট Bwina https://bwina888.com/ সাইটে সরাসরি লগ ইন করে এবং আপনার প্রিয় গেম ও প্রচারাভিযানগুলি উপভোগ করতে পারবেন।
            </p>
            <p *ngIf="languageCode != 'bn'">
              If you encounter any issues or have questions, please do not hesitate to contact our support team for assistance.
            </p>
            <p *ngIf="languageCode == 'bn'">
              যদি কোনো সমস্যা হয় বা কোনো প্রশ্ন থাকে, তবে অামাদের সহায়তা দলের সাথে যোগাযোগ করতে দ্বিধা করবেন না।
            </p>
            <p *ngIf="languageCode != 'bn'">
              Thank you for your continued support, and we look forward to serving you on Bwina!
            </p>
            <p *ngIf="languageCode == 'bn'">
              আপনার সমর্থনের জন্য ধন্যবাদ, এবং আমরা Bwina-তে আপনাকে সেবা দিতে উৎসুক।
            </p>
          </div>
          <hr class="maintenance-line">
          <div class="d-flex justify-content-between mt-4">
            <button class="contact-btn" (click)="redirectToLiveChat()">Contact us</button>
            <button class="login-btn" (click)="redirectToLogin()">Login BwinA</button>       
          </div>
        </div>

        <!-- other maintenance rather than qp16-->
        <div class="maintenance-container maintenance-margin" *ngIf="sitePrefix != 'lb'">
          <div class="maintenance-header-text">
            {{ 'This page is under maintenance. Please check back again soon.' | translate | uppercase }}
          </div>
          <div class="col-12 d-flex justify-content-center">
            <div class="maintenance-logo" [innerHTML]="svg.underMaintenanceIcon | safeHtml"></div>
          </div>
          <p class="maintenance-text">
            {{ '[site_name] regular scheduled maintenance to bring you the best possible online casino experience. Thank you for your patience and continuous support.' | translate : { site_name : siteName } }}
          </p>
          <hr class="maintenance-line">
          <p class="maintenance-text-two">
            {{ 'We\'ll be back at' | translate }} : <br>
          </p>
          <h6 class="maintenance-time-text" *ngIf="countryCode != 'bd'">
            {{ returnDateTime | uppercase }} (GMT+8) <span class="mb-0 maintenance-color" *ngIf="languageCode == 'TH'"> น. </span>
          </h6>
          <h6 class="maintenance-time-text" *ngIf="countryCode == 'bd'">
            {{ returnDateTime | uppercase }} (GMT+6) <span class="mb-0 maintenance-color" *ngIf="languageCode == 'TH'"> น. </span>
          </h6>
        </div>
      </div>
    </div>
  </div>
</section>